import { useProgress } from '@react-three/drei'
import { useState, useEffect } from 'react'

export default function CustomLoader() {
  const { progress, active } = useProgress()
  const [displayProgress, setDisplayProgress] = useState(0)
  const [phase, setPhase] = useState('loading') // loading | holding | finishing | done

  useEffect(() => {
    if (phase === 'done') return

    if (phase === 'loading') {
      // Clamp to 99% max during loading phase
      const clamped = Math.min(Math.floor(progress), 99)
      setDisplayProgress(clamped)

      // When actual loading reaches 100%, go to holding phase
      if (progress >= 100) {
        setDisplayProgress(99)
        setPhase('holding')
      }
    }
  }, [progress, phase])

  useEffect(() => {
    if (phase === 'holding') {
      // Hold at 99% for 1 second, then finish
      const timer = setTimeout(() => {
        setDisplayProgress(100)
        setPhase('finishing')
      }, 1000)
      return () => clearTimeout(timer)
    }

    if (phase === 'finishing') {
      // Wait for exit animation to complete
      const timer = setTimeout(() => {
        setPhase('done')
      }, 800)
      return () => clearTimeout(timer)
    }
  }, [phase])

  if (phase === 'done') return null

  return (
    <div
      className={`custom-loader ${phase === 'finishing' ? 'loader-exit' : ''}`}
    >
      <div className="loader-content">
        <div className="loader-logo">
          <img src="/logo.svg" alt="Suzuki" width="50" height="40" />
          <span className="loader-brand">SUZUKI <strong>GSX 750</strong></span>
        </div>

        <div className="loader-bar-wrapper">
          <div className="loader-bar-track">
            <div
              className="loader-bar-fill"
              style={{ width: `${displayProgress}%` }}
            />
          </div>
        </div>

        <div className="loader-info">
          <span className="loader-percent">{displayProgress}%</span>
          <span className="loader-status">
            {phase === 'holding' ? 'Almost ready...' : 'Loading assets...'}
          </span>
        </div>
      </div>
    </div>
  )
}
